import { Check, X } from "@phosphor-icons/react";
import { useState } from "react";

import { Button } from "common/components/ui/Button";
import { CountSpinner } from "common/components/ui/CountSpinner";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useLicenseMutations from "common/datahooks/useLicenseMutations";
import usePromotions from "common/datahooks/usePromotions";
import useLicensedAccounts from "common/hooks/useLicensedAccounts";

export default function ManageAgencySeats() {
  const [isEditing, setIsEditing] = useState(false);

  const { id: workspaceId, agency_license_count } =
    useSelectedWorkspaceContext();
  const { agencyPlan } = usePromotions();
  const { agencyLicensedAccounts } = useLicensedAccounts(workspaceId);
  const { setLifetimeLicenseCount, isSettingLifetimeLicenseCount } =
    useLicenseMutations();

  const [seatCount, setSeatCount] = useState(agency_license_count);

  const unassignedLicenseCount = agencyPlan?.unassigned_license_count ?? 0;

  async function onSubmit() {
    if (seatCount !== agency_license_count) {
      await setLifetimeLicenseCount({
        workspaceId,
        count: seatCount,
        source: "agency",
        accountsToCancel: [],
      });
    }
    setIsEditing(false);
  }

  if (!isEditing) {
    return (
      <Button
        size="sm"
        variant="secondary-purple"
        onClick={() => {
          setSeatCount(agency_license_count);
          setIsEditing(true);
        }}
      >
        Allocate seats
      </Button>
    );
  }

  return (
    <div className="flex gap-x-2 items-center">
      <CountSpinner
        variant="sm"
        value={seatCount}
        setValue={setSeatCount}
        minValue={agencyLicensedAccounts.length}
        maxValue={agency_license_count + unassignedLicenseCount}
        minValueTooltipText="These seats are already assigned to LinkedIn accounts. Go to the Accounts page in the workspace to unassign them."
        maxValueTooltipText="No available seats left. Upgrade your plan or free up seats in another workspace."
      />

      <Button
        variant="secondary-black"
        size="sm"
        intent="iconOnly"
        disabled={isSettingLifetimeLicenseCount}
        onClick={() => {
          setSeatCount(agency_license_count);
          setIsEditing(false);
        }}
      >
        <X />
      </Button>

      <Button
        variant="secondary-purple"
        size="sm"
        intent="iconOnly"
        isLoading={isSettingLifetimeLicenseCount}
        onClick={onSubmit}
      >
        <Check />
      </Button>
    </div>
  );
}
